import * as React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { User, ShieldCheck, ChevronsUpDown } from "lucide-react"
import { useUser } from "../../../hooks/useUser"
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  useSidebar,
} from "../../../components/ui/sidebar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu"

export function ViewSwitcher() {
  const { isAdmin } = useUser()
  const location = useLocation()
  const navigate = useNavigate()
  const { isMobile } = useSidebar()

  // Don't show for non-admin users
  if (!isAdmin) return null

  const isAdminView = location.pathname.startsWith('/admin')

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              {isAdminView ? (
                <>
                  <ShieldCheck className="size-4 text-warning" />
                  <div className="grid flex-1 text-left text-sm leading-tight">
                    <span className="truncate font-semibold">Admin Panel</span>
                  </div>
                </>
              ) : (
                <>
                  <User className="size-4" />
                  <div className="grid flex-1 text-left text-sm leading-tight">
                    <span className="truncate font-semibold">User View</span>
                  </div>
                </>
              )}
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="start"
            sideOffset={4}
          >
            <DropdownMenuItem
              onClick={() => navigate('/dashboard')}
              className="gap-2 p-2"
            >
              <User className="size-4" />
              <span>User View</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => navigate('/admin/overview')}
              className="gap-2 p-2"
            >
              <ShieldCheck className="size-4 text-warning" />
              <span>Admin Panel</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
